import * as marietta from '../..';
import { ItemLayer } from '.';
import { SVGSprite } from '../flash/display';
import { ITEM_MODE_NAME_ENG } from '../Constants';
import { Shitae } from '../item';
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist/build/pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

export default class ShitaeLayer extends ItemLayer {
  public spt: SVGSprite;

  parent: marietta.webcad.layer.FloorLayer;

  imgSrc: string;

  defaultItemInfo: marietta.webcad.collection.ItemInfoCollection;

  defaultScale: number;

  reader: FileReader;

  /**
   * constructor
   */
  constructor(_no: number, _name: string, _key: string, layer: SVGSprite, parent) {
    super(_no, _name, _key, layer);

    this.parent = parent;
    this.defaultItemInfo = new marietta.webcad.collection.ItemInfoCollection();
  }

  /**
   * 下絵読み込みボタンがクリックされた
   */
  startLoadEventHandler = () => {
    const self = this;
    if (this.childList.length > 0) {
      marietta.webcad.WebCADGlobal.showConfirmDialog(marietta.webcad.collection.WebCADMessages.getText('CONFIRM_RELOAD_DRAFT'), '', self.load);
    } else {
      this.load();
    }
  }

  /**
   * 下絵取り込み
   */
  load = () => {
    // 既に下絵がある場合は破棄する
    if (this.childList.length > 0) this.removeAllChildren();

    // 下絵取り込み
    const self = this;
    document.querySelector('#samplePictureInput').addEventListener('change', self.onSelectHandler);
    (<HTMLInputElement>document.querySelector('#samplePictureInput')).click();
  }

  /**
   * 下絵取り込み ファイル選択された
   */
  onSelectHandler = (e) => {
    const self = this;
    const file = e.target.files[0];
    switch (file.type) {
      case 'image/png':
      case 'image/jpeg':
      case 'image/gif':
        this.reader = new FileReader();
        this.reader.addEventListener('load', self.onCompleteHandler);
        this.reader.addEventListener('error', self.onErrorHandler);
        this.reader.readAsDataURL(file);
        break;
      case 'application/pdf':
        this.reader = new FileReader();
        this.reader.addEventListener('load', self.onCompleteHandlerPDF);
        this.reader.addEventListener('error', self.onErrorHandler);
        this.reader.readAsDataURL(file);
        break;
      default:
        // 下絵の読込に失敗しました。<br> PNG、JPEG、GIF形式の画像を選択してください。
        marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_DRAFT_FAIL'));
        break;
    }
    (document.querySelector('#samplePictureInput').removeEventListener('change', self.onSelectHandler));
    (<HTMLInputElement>document.querySelector('#samplePictureInput')).value = null;
  }

  /**
   * 下絵読み込み 読み込みに成功した
   */
  onCompleteHandler = (e) => {
    this.removeFileReferenceEvents();

    // 左のアイテムメニューの領域分マージンを取得
    const marginSize = (<HTMLElement>document.getElementById('itemMenu_shitae')).offsetWidth;

    marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementPlus();

    // 表示中のステージの座標を取得

    const stageBound = (<HTMLElement>document.getElementById('webcad2dViewInner')).getBoundingClientRect();
    const layerGroupBound = (<HTMLElement>document.getElementById('layerGroup')).getBoundingClientRect();
    const scrollBarWidth = parseFloat(window.getComputedStyle((<HTMLElement>document.getElementById('webcad2dViewInner'))).width) - (<HTMLElement>document.getElementById('webcad2dViewInner')).clientWidth;
    const minPoint: marietta.core.Point = new marietta.core.Point((stageBound.left + marginSize - layerGroupBound.left) / marietta.webcad.WebCADGlobal.scaleSize, (stageBound.top - layerGroupBound.top) / marietta.webcad.WebCADGlobal.scaleSize);
    const maxPoint: marietta.core.Point = new marietta.core.Point(minPoint.x + ((stageBound.width - scrollBarWidth - marginSize) / marietta.webcad.WebCADGlobal.scaleSize), minPoint.y + ((stageBound.height - scrollBarWidth) / marietta.webcad.WebCADGlobal.scaleSize));
    const motoCenter: marietta.core.Point = new marietta.core.Point((maxPoint.x + minPoint.x) / 2, (maxPoint.y + minPoint.y) / 2);

    // アイテム作成
    const info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
    info.id = ITEM_MODE_NAME_ENG.MODE_SHITAE_NAME_ENG;
    info.imgSrc = e.target.result;
    this.imgSrc = e.target.result;
    const bound = marietta.webcad.util.WebCADUtil.getStageArea();
    info.dotList = [
      new marietta.webcad.collection.PointCollection(0, 0, 0),
      new marietta.webcad.collection.PointCollection(bound.width, 0, 0),
      new marietta.webcad.collection.PointCollection(bound.width, bound.height, 0),
      new marietta.webcad.collection.PointCollection(0, bound.height, 0),
    ];
    info.x = motoCenter.x;
    info.y = motoCenter.y;
    info.width = maxPoint.x - minPoint.x;
    info.height = maxPoint.y - minPoint.y;
    info.guid = marietta.webcad.WebCADGlobal.getGuid();

    // アイテムインフォを保持
    this.defaultItemInfo = Object.assign(this.defaultItemInfo, info);
    this.endItemLoad(info);
  }

  onCompleteHandlerPDF = () => {
    // BUSY
    marietta.webcad.WebCADGlobal.showBusy('処理中...');

    const scope: ShitaeLayer = this;
    const pdfAsArray = this.convertDataURIToBinary(scope.reader.result);
    GlobalWorkerOptions.workerSrc = pdfjsWorker;
    const loadingTask = getDocument(pdfAsArray);
    loadingTask.promise.then((pdf) => {
      // BUSY
      marietta.webcad.WebCADGlobal.hideBusy();

      // 複数ページがあるときは選択ダイアログ
      if (pdf.numPages > 1) {
        const dialog: any = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.SelectPdfPage);
        dialog.maxPages = pdf.numPages;
        dialog.callBack = scope.loadPDFPage;
        dialog.pdf = pdf;
      } else {
        // １ページ目を表示
        scope.loadPDFPage(pdf, 1);
      }
    }, (error) => {
      console.log(error);
      marietta.webcad.WebCADGlobal.showAlert('下絵の取込みに失敗しました。');

      // BUSY非表示
      marietta.webcad.WebCADGlobal.hideBusy();
    });
  }

  /**
     * PDFページを読み込む
     * @param pdf
     * @param pageNo
     */
  loadPDFPage = (pdf, pageNo) => {
    const scope: ShitaeLayer = this;

    // BUSY
    marietta.webcad.WebCADGlobal.showBusy('読込中...');

    pdf.getPage(pageNo).then((page) => {
      const scale = 5;
      const viewport = page.getViewport({ scale });
      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        if (viewport.height * viewport.width > 16777216) {
          // BUSY非表示
          marietta.webcad.WebCADGlobal.hideBusy();
          marietta.webcad.WebCADGlobal.showAlert('PDFまたは画像の幅と高さが大きすぎ、iPadの制限を超えています。<br> 別のPDFまたは画像を使用するか、PCで行ってください');
          return;
        }
      }
      const canvas: HTMLCanvasElement = <HTMLCanvasElement>document.getElementById('dummyPdfCanvas');
      const context = canvas.getContext('2d');
      canvas.style.height = `${viewport.height}px`;
      canvas.style.width = `${viewport.width}px`;

      canvas.height = viewport.height;
      canvas.width = viewport.width;
      const renderContext = { canvasContext: context, viewport };

      const renderTask = page.render(renderContext);

      renderTask.promise.then(() => {
        // JPEG画像に出力するよう修正
        const image64 = canvas.toDataURL('image/jpeg', 0.9);
        // サイズを調べてから処理実行
        const img = new Image();
        img.onload = () => {
          const marginSize = document.getElementById('itemMenu_shitae').offsetWidth;

          marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementPlus();
          // 表示中のステージの座標を取得
          const stageBound = document.getElementById('webcad2dViewInner').getBoundingClientRect();
          const layerGroupBound = document.getElementById('layerGroup').getBoundingClientRect();
          const scrollBarWidth = document.getElementById('webcad2dViewInner').offsetWidth - document.getElementById('webcad2dViewInner').clientWidth;
          const minPoint: marietta.core.Point = new marietta.core.Point((stageBound.left + marginSize - layerGroupBound.left) / marietta.webcad.WebCADGlobal.scaleSize, (stageBound.top - layerGroupBound.top) / marietta.webcad.WebCADGlobal.scaleSize);
          const maxPoint: marietta.core.Point = new marietta.core.Point(minPoint.x + ((stageBound.width - scrollBarWidth - marginSize) / marietta.webcad.WebCADGlobal.scaleSize), minPoint.y + ((stageBound.height - scrollBarWidth) / marietta.webcad.WebCADGlobal.scaleSize));
          const motoCenter: marietta.core.Point = new marietta.core.Point((maxPoint.x + minPoint.x) / 2, (maxPoint.y + minPoint.y) / 2);

          // アイテム作成
          const info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
          info.id = ITEM_MODE_NAME_ENG.MODE_SHITAE_NAME_ENG;
          info.imgSrc = image64;
          scope.imgSrc = image64;
          const bound = marietta.webcad.util.WebCADUtil.getStageArea();
          info.dotList = [
            new marietta.webcad.collection.PointCollection(0, 0, 0),
            new marietta.webcad.collection.PointCollection(bound.width, 0, 0),
            new marietta.webcad.collection.PointCollection(bound.width, bound.height, 0),
            new marietta.webcad.collection.PointCollection(0, bound.height, 0),
          ];
          info.x = motoCenter.x;
          info.y = motoCenter.y;
          info.width = maxPoint.x - minPoint.x;
          info.height = maxPoint.y - minPoint.y;

          // アイテムインフォを保持
          if (scope.defaultItemInfo == null) scope.defaultItemInfo = new marietta.webcad.collection.ItemInfoCollection();
          scope.defaultItemInfo = Object.assign(scope.defaultItemInfo, info);
          this.endItemLoad(info);
        };
        // 読込
        img.src = image64;
      });
    });
  }

  endItemLoad =(info: marietta.webcad.collection.ItemInfoCollection) => {
    marietta.webcad.WebCADGlobal.itemManager.createItem(info);
    marietta.webcad.WebCADGlobal.hideBusy();
    // 下絵自動拡縮モードへ
    marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.ShitaeFitDialog, true, true, false);
    // FloorLayerのすべてのレイヤーを非表示にします
    this.showHideAllFloorLayers(false);
  }

  /**
   * Uint8Array convert
   * @param dataURI
   * @returns
   */
  convertDataURIToBinary = (dataURI) => {
    const BASE64_MARKER = ';base64,';
    const base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
    const base64 = dataURI.substring(base64Index);
    const raw = window.atob(base64);
    const rawLength = raw.length;
    const array = new Uint8Array(new ArrayBuffer(rawLength));

    for (let i = 0; i < rawLength; i += 1) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }

  /**
   * 下絵読み込み 読み込みに失敗した
   */
  onErrorHandler = (e) => {
    console.error(e.target.error.message);
    // ファイルの読込に失敗しました。
    marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ERROR_LOAD_FAIL'));
    this.removeFileReferenceEvents();
  }

  /**
   * 間取りのインポートイベントの削除
   */
  removeFileReferenceEvents() {
    const self = this;
    this.reader.removeEventListener('load', self.onCompleteHandler);
    this.reader.removeEventListener('error', self.onErrorHandler);
  }

  /**
   * コントローラを表示
   */
  openController = () => {
    marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.ShitaeControllerDialog, true, true, false);
  }

  show() {
    this.spt.show();
  }

  hide() {
    this.spt.hide();
  }

  /**
   * 表示/非表示
   */
  changeImageVisible(bool: boolean) {
    if (bool) {
      (this.childList[0] as Shitae).show();
    } else {
      (this.childList[0] as Shitae).hide();
    }
  }

  /**
   * 透過度を変更
   */
  changeOpactiy(num: number) {
    (this.childList[0] as Shitae).changeOpactiy(num);
  }

  /**
   * 下絵を最初の状態に戻す
   */
  resetImage() {
    const info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
    // info = Object.assign(info, this.defaultItemInfo);
    // marietta.webcad.WebCADGlobal.itemManager.createItem(info);
    this.childList[0].itemInfo = Object.assign(info, this.defaultItemInfo);
    this.childList[0].updateTransforms();
    if (!Number.isNaN(this.defaultScale)) {
      this.childList[0].spt.scaleX = this.defaultScale;
      this.childList[0].spt.scaleY = this.defaultScale;
      this.childList[0].spt.update();
    }
  }

  showHideAllFloorLayers = (show: boolean = true) => {
    for (let i: number = 1; i <= 3; i += 1) {
      const floorLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(i) as marietta.webcad.layer.FloorLayer;
      const { allLayers } = floorLayer as marietta.webcad.layer.FloorLayer;
      for (let j: number = 0; j < allLayers.length; j += 1) {
        if (show) {
          (allLayers[j].spt.element).style.display = 'block';
        } else {
          (allLayers[j].spt.element).style.display = 'none';
        }
      }
    }
    if (!show) {
      if (document.getElementById('controller') != null) document.getElementById('controller').remove();
    }
  }
}
